import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_pistachio_croissant.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganPistachioCroissant() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Pistachio Croissant",
    content_category: "Vegan Menu",
    content_ids: ["vegan_pistachio_croissant"],
    content_type: "vegan_pastries",
    value: 6.00,
    currency: "USD",
  });

  const pageTitle = "Vegan Pistachio Croissant | Đông Hưng Viên Bakery";
  const pageDescription =
    "A flaky vegan croissant with a velvety pistachio center and just enough sweetness to keep it addictive.";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Vegan Pistachio Croissant"
          titleSubHead="$6.00 each"
          detailBody="A flaky vegan croissant with a velvety pistachio center and just enough sweetness to keep it addictive."
          detailBodyBr="Contains: wheat, almond, pistachio, sesame"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganPistachioCroissant;